import React, { Component, Fragment } from 'react';
import { Button, Icon, Loader, Segment } from 'semantic-ui-react';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import { checkFaculty, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE, getTotalNumberOfPages } from '../../util/util';
import NewRoom from '../../Rooms/NewRoom';
import { fetchActiveRole, fetchUserOrganizationalUnit } from '../../util/roles';
import { FiltersOnStyle } from '../../../Professor/ProfessorInputGrades/css';
import RoomList from '../../Rooms/RoomList';
import PaginationSegment from '../../util/PaginationSegment';


class Rooms extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            rooms: [],
            openNewRoom: false,
            loader: true,
            activeRole: '',
            activePage: 1,
            totalPages: 1,
            resultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
            filterRequestData: null,
        };
        this.getUserData = this.getUserData.bind(this);
        this.fetchAllRooms = this.fetchAllRooms.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.updateRooms = this.updateRooms.bind(this);
    }

    componentDidMount() {
        this.getUserData();
    }

    getUserData() {
        axios.all([fetchActiveRole(), fetchUserOrganizationalUnit()])
            .then(axios.spread((activeRoleRes, userOrganizationalUnitRes) => {
                const activeRole = activeRoleRes.data;
                const organizationalUnitId = userOrganizationalUnitRes.data;
                this.setState({ activeRole, organizationalUnitId });
                if (checkFaculty(activeRole)) {
                    this.fetchAllRooms();
                } else {
                    this.fetchAllRooms();
                }
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch data.');
            });
    }

    fetchAllRooms(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        this.fetchRooms(page, resultsPerPage).then((res) => {
            const rooms = res.data.responseList;
            let totalPages = getTotalNumberOfPages(res.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
            this.setState({ rooms, totalPages, loader: false });
            this.updateRooms(page, resultsPerPage, res);
        });
    }

    fetchRooms(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };
        return axios.post(`/assets/rooms/by-org-unit-and-property/paginated/${this.props.orgUnitProperty.property.id}`, { ...pagination });
    }

    handlePageChange(e, { activePage }) {
        if (activePage === this.state.activePage) {
            return;
        }

        if (this.state.showFiltersOnButton) {
            this.getFilteredRooms(activePage - 1, this.state.resultsPerPage);
        } else {
            this.fetchAllRooms(activePage - 1, this.state.resultsPerPage);
        }
    }

    updateRooms(page, resultsPerPage, res) {
        let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);

        this.setState(prevState => ({
            activePage: page + 1,
            resultsPerPage,
            totalPages
        }));
    }

    render() {
        const { rooms } = this.state;
        return (
            <div>


                {!this.state.openNewRoom && checkFaculty(this.state.activeRole) && <Button
                    color="blue"
                    floated="right"
                    size="small"
                    style={FiltersOnStyle}
                    onClick={() => this.setState({ openNewRoom: true })}
                ><Icon className="add" />
                        Dodavanje prostorije
                </Button>}
                {!this.state.openNewRoom && checkFaculty(this.state.activeRole) && <br />}
                {/* eslint-disable-next-line react/jsx-no-undef */}
                {this.state.openNewRoom &&
                <NewRoom
                    organizationalUnitId={this.state.organizationalUnitId}
                    activeRole={this.state.activeRole}
                    fetchAllRooms={this.fetchAllRooms}
                    closeForm={() => this.setState({ openNewRoom: false })}
                    property={this.props.orgUnitProperty.property}
                    orgUnitProperty={this.props.orgUnitProperty}
                />}
                {this.state.loader ?
                    <Loader active inline="centered" />
                    :
                    rooms && rooms.length ?

                        <Fragment>
                            <RoomList
                                rooms={rooms}
                                activateEditRequest={this.activateEditRequest}
                            />
                            <PaginationSegment
                                activePage={this.state.activePage}
                                totalPages={this.state.totalPages}
                                onPageChange={this.handlePageChange}
                            />
                        </Fragment>

                        : 'Nema podataka o prostorijama.'
                }


                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default Rooms;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/Details/Rooms.js